import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaStar } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { httpReauest } from "utils/httpRequest";

const ProductComments = ({ data }) => {
  const [isLogin, setIsLogin] = useState(false);
  const [user, setuser] = useState(false);
  const [content, setContent] = useState();
  const [rate, setrate] = useState();

  const [t] = useTranslation("global");
  async function getUser(_id, token) {
    await httpReauest(
      "GET",
      "/user/info/" + _id,
      {},
      { "x-access-token": token }
    )
      .then((res) => {
        setuser(res.data.data);
      })
      .catch(() => {
        localStorage.removeItem("user");
      });
  }

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user) {
      setIsLogin(true);
      getUser(user._id, user.token);
    }
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    const user = JSON.parse(localStorage.getItem("user"));

    if (!rate || !content) {
      toast.error("Check all filds");
    }

    await httpReauest(
      "POST",
      "/product/addReview/" + data?._id,
      { content, rate },
      { "x-access-token": user.token }
    )
      .then((e) => {
        toast.success("Sucessfull");
        setContent("");
        window.location.reload();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  }
  return (
    <div class="col-span-full w-full mt-10">
      <h2 className="text-[20px] lg:text-[40px] mb-6 lg:mb-8 text-[#292929] font-bold">
        {t("reviews")}
      </h2>
      <div className="w-full grid lg:grid-cols-3">
        <span className="lg:col-span-2 flex flex-col gap-3">
          {data?.reviews?.map((review) => {
            return (
              <div class="border-2 border-[#D4D4D4] rounded-[8px] p-3">
                <div class="flex justify-between items-center">
                  <span class="text-[#1B1F37] text-[18px]">
                    {review?.userId?.name}
                  </span>
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, index) => (
                      <FaStar
                        key={index}
                        className={`text-[16px] ${
                          index < data?.rate
                            ? "text-yellow-400"
                            : "text-gray-300"
                        }`}
                      />
                    ))}
                  </div>
                </div>

                <p class="text-[16px] text-[#292929] mt-3">{review?.content}</p>
              </div>
            );
          })}
        </span>
        <div class=" rounded-[16px] p-3 lg:p-4">
          {isLogin ? (
            <form class="pd-tab__rev-f2">
              <p className="text-[#000] text-[20px]">
                {t("what-is-your-comment")}
              </p>
              <div class="rev-f2__group">
                <div class="u-s-m-y-15">
                  <textarea
                    class="border-[1px] border-[#737373] rounded-[4px] w-full outline-none h-[128px] p-3 text-[#737373]"
                    placeholder={t("your-review")}
                    id="reviewer-text"
                    onChange={(e) => setContent(e.target.value)}
                    value={content}
                  ></textarea>
                </div>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-[#292929] text-[18px]">
                  {t("gave-rate-to-this")}:
                </span>
                <span
                  dir="ltr"
                  className="flex gap-1 items-center cursor-pointer"
                >
                  {rate &&
                    Array(rate)
                      .fill("")
                      .map((item, index) => (
                        <FaStar
                          onClick={() => setrate(index + 1)}
                          className="text-yellow-400 text-[16px]"
                        />
                      ))}
                  {rate &&
                    Array(5 - rate)
                      .fill("")
                      .map((item, index) => (
                        <FaStar
                          onClick={() => setrate(rate + index + 1)}
                          class="text-[16px] text-gray-300"
                        />
                      ))}
                  {!rate &&
                    Array(5)
                      .fill("")
                      .map((item, index) => (
                        <FaStar
                          onClick={() => setrate(index + 1)}
                          class="text-[16px] text-gray-300"
                        />
                      ))}
                </span>
              </div>
              <div className="mt-4">
                <button
                  class="py-2 hover:bg-red-100 duration-200 w-full text-[18px] text-red-500 border-[1px] rounded-full border-red-500"
                  type="submit"
                  onClick={handleSubmit}
                >
                  {t("submit-comment-and-rate")}
                </button>
              </div>
            </form>
          ) : (
            <div class="pd-tab__rev-f2">
              <span className="text-[#292929] text-[20px] text-center flex flex-col items-center justify-center">
                {t("sign-for-comment")}
                <Link
                  to={"/sign"}
                  class=" px-3 py-2 bg-red-100 duration-200 text-[18px] text-red-500 border-[1px] rounded-full border-red-500 mt-3"
                >
                  {t("sign")}
                </Link>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductComments;
